import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { debounce as _debounce } from 'es-toolkit';
import { random as _random } from 'es-toolkit';
import DOMHelpers from './utils/dom-helpers';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

// register plugins
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, DrawSVGPlugin);

export default class EFFEX {

	constructor(options) {

		this.defaults = {
			debug: false,
			duration_logo_anim: 2000, // pixels

			optimizeMobile: true
		}
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = 'effx';

		// DOM helpers + vanilla DOM refs (jQuery removed)
		this.dom = new DOMHelpers(document);

		/*
		this.qs = this.dom.qs.bind(this.dom);
		this.qsa = this.dom.qsa.bind(this.dom);
		this.on = this.dom.on.bind(this.dom);
		this.off = this.dom.off.bind(this.dom);
		this.addClass = this.dom.addClass.bind(this.dom);
		this.removeClass = this.dom.removeClass.bind(this.dom);
		this.hasClass = this.dom.hasClass.bind(this.dom);
		this.htmlToDoc = this.dom.htmlToDoc.bind(this.dom);
		*/

		this.window = window;
		this.document = document;
		this.htmlEl = document.documentElement;
		this.body = document.body;

		this.main = this.options.main;

		this.resize_timeout = null;
		this.ids = [];

	}

	init( fistTime=false ) {


		//console.log( "EFFEX init", fistTime );

		this.addEvents(true);
		this.initLogoHomeAnimation();
		this.initDesktopHeaderSticky();
		clearTimeout( this.id_timeout_overlap );
		//this.checkMainWhenOverlapHeader();
		this.id_timeout_overlap = setTimeout( ()=>this.checkMainWhenOverlapHeader(), 100 );
		this.animateBackgroundGradient();
		this.initEffectParallaxBackgroundImages();
		clearTimeout( this.id_timeout_images );
		this.id_timeout_images = setTimeout( ()=>this.checkImagesInView(), 0 );
		clearTimeout( this.id_timeout_scroll_text );
		this.id_timeout_scroll_text = setTimeout( ()=>this.initScrollText(), 300 ); // wait for slideshow to be initialized to calculate correctly the heights
		clearTimeout( this.id_timeout_mobile_header );
		this.id_timeout_mobile_header = setTimeout( ()=>this.initMobileTabletHeaderHide(), 17 ); 

		//setTimeout( ()=>this.moveFooter( true ), 377 );

		//this.setNavigationState();
		//this.lockTimelineSidebar();
		//this.lockShareButtons();

		/*
		this.initScrollColsAtDifferentSpeed();
		*/

		//this.initParallax();
		//this.initParallaxWorks();
		//this.initEffectParallaxImage();
		//this.initEffectParallaxImageSmoothTravelling();

		/*
		//------------------- desktop ---------------------//
		this.initNavCompact();
		this.setBurgerPin();

		//------------------- mobile ---------------------//
		this.setMobileHeaderPin();

		setTimeout( ()=>this.setBurgerMobilePin(), 0);

		this.setMenuSubPagesMobilePin();
		this.initMobileSubmenuPages();
		this.initSubmenuPages();

		this.initSubmenuSticky();
		setTimeout( ()=>this.checkView(), 277 );

		this.initModuleHortFiltersSticky();
		*/

		/*
		if ( this.hasClass(this.body, 'home') ){
			this.randomizeGradientHover( true );
		}
		*/

		// this.initScrollDownArrow();

	}

	reset() {
		clearTimeout( this.resize_timeout );
		this.destroy();
		this.resize_timeout = setTimeout( ()=>this.init(), 27 );
	}

	//------------------------------------------ UTILS -----------------------------------------//
	addEvents(b) {
		if (b) {
			this.r = _debounce(() => { this.onResize() }, 60 );
			window.addEventListener('resize', this.r);
		}
		else {
			if (this.r) {
				this.r.cancel && this.r.cancel();
				window.removeEventListener('resize', this.r);
			}
		}
	}

	onResize() {
		this.reset()
	}

	getWindowHeight() {
		return window.innerHeight || this.document.documentElement.clientHeight;
	}
	getDocHeight() {
		const d = this.document;
		return Math.max(
			d.body.scrollHeight, d.documentElement.scrollHeight,
			d.body.offsetHeight, d.documentElement.offsetHeight,
			d.documentElement.clientHeight
		);
	}




	//------------------------------------------ EFFECTS -----------------------------------------//
	/* Converted legacy jQuery blocks below: each block preserved as commented code but rewritten using DOMHelpers / vanilla DOM.
	   Remove the comment markers to enable any effect and adapt selectors/options as needed.
	*/
	initDesktopHeaderSticky(){

		const desktop = this.isDesktop();
		const el = desktop ? this.dom.qs('.header-desktop') : this.dom.qs('.header-mobile');

		//console.log( el );

		if (!el) return;

		//if ( this.options.optimizeMobile && this.isMobile() ) return;
		if ( !desktop ) return;

		const int = el.querySelector( '.layout' );
		const logo = el.querySelector( '.logo' );
		const m 	= this.dom.qs( '#main' );
		const active = window.innerWidth >= 1024;
		const lockSubmenus = false;
		//const c 	= m.querySelector( '.main-content' );
		const duration = !active ? 0 : Math.min( this.getDocHeight() - this.getWindowHeight() - 64, this.options.duration_logo_anim );

		//console.log( duration );
		

		if ( desktop ){
			if ( this.dom.hasClass( this.body, 'home' ) ){

				window.scrollTo(0, 0);

				gsap.set( int, {height: 280 } );
				
				gsap.set( logo, {width:'100%'} );
				//gsap.set( logo, {scale:1} );


				let w = logo.offsetWidth,
				s = 280/w;


				// Header/Logo Animation
				let t = gsap.timeline( { 
					scrollTrigger: {
						trigger: el,
						start: "top top+=20px",
						end:  '+=' + duration + 'px',
						scrub: true,
						markers: false,
						id: this.getID(),
						//pin: el,
						//pinSpacing: false,
						onUpdate: (self) =>{
							//console.log( self );
						}
					} 
				});
				t.to( logo, { width: 280, duration: 1, ease: 'power2.out'  } );
				//t.to( logo, { scale: s, transformOrigin: "top left", duration:1, ease: 'power1.out'  }, "-=0" );
				t.to( int,  { height: 64, duration:1, ease: 'power1.out'  }, "-=1" );

				// simulate as the content is pinned the move
				//t.to( c,  	{ y: - 280 + 64, duration:1, ease: 'power1.out'  }, "-=1" );

				
				// pin all the content
				/*
				ScrollTrigger.create({
					trigger: el,
					start: "top top+=20px",
					end : duration + 'px',
					scrub: false,
					markers: false,
					id: this.getID(),
					pin: m
				});	
				*/

				// reposition the content at its position
				/*
				gsap.to( c , {
					y: 0,
					scrollTrigger: {
						trigger: el,
						start: "top top",
						end: (280-64) + 'px',
						markers: true,
						id: this.getID()
					}
				});
				*/
				
			}
			else{
				gsap.set( int, { height: 64} );
				gsap.set( logo, {width:'280'} );
				
				/*
				gsap.set( logo, {width:'100%'} );
				let w = this.document.querySelector( '#header .layout').offsetWidth,
				s = 280/w;
				gsap.set( logo, {scale:s, transformOrigin: 'top left' } );
				*/
			}
		}


		//---------------------------- lock header -------------------------------//
		const 	footer =  this.dom.qs('#footer'),
				submenu = this.dom.qs( '.menu-subpages-view' ),
				endTrigger = submenu && lockSubmenus ? submenu : footer,
				end = submenu && lockSubmenus ? 'top top+=84px' : 'top top';


		

		// header lock
		ScrollTrigger.create({
			trigger: el,
			start: "top top",
			pin: el,
			pinSpacing: false,
			endTrigger: endTrigger,
			toggleClass: 'desktop-locked-header',
			end: end,
			scrub: true,
			markers: false,
			id: this.getID(),

			onUpdate: self =>{
				//console.log( self );
				if ( self.progress > 0 ){
					if (  int.getBoundingClientRect().height <= 66  ){
						if (self.isActive) {
							this.dom.addClass(this.body, 'desktop-header-sticky');
						}
						else{
							if ( self.progress < 1 ){
								this.dom.removeClass(this.body, 'desktop-header-sticky');
							}
						} 
					}
					else{
						this.dom.removeClass(this.body, 'desktop-header-sticky');
					}
				}
				else{
					this.dom.removeClass(this.body, 'desktop-header-sticky');
				}
			}
		});

		
		if ( submenu && lockSubmenus ){
			// lock submenu
			ScrollTrigger.create({
				trigger: submenu,
				start: "top top+=20px",
				pin: submenu,
				pinSpacing: false,
				endTrigger: footer,
				end: "top top",
				scrub: true,
				markers: false,
				id: this.getID()
			});
		}
		
	}

	/*
	initDesktopHeaderStickyBackUp(){
		const el = this.dom.qs('.header-desktop');

		//console.log( el );

		if (!el) return;

		const int = el.querySelector( '.layout' );
		const logo = el.querySelector( '.logo' );

		if ( this.dom.hasClass( this.body, 'home' ) ){
			gsap.set( int, {height: 280 } );
			gsap.set( logo, {width:'100%'} );
		}
		else{
			gsap.set( int, { height: 64} );
			gsap.set( logo, {width:'280'} );
		}

		const l = this.getDocHeight() - this.getWindowHeight();

		ScrollTrigger.create({
			trigger: el,
			start: "top top",
			pin: el,
			pinSpacing: false,
			//end: l, //() => { return this.getDocHeight() - this.getWindowHeight(); },
			endTrigger: this.dom.qs('#footer'),
			end: "top top",
			scrub: true,
			markers: false,
			id: this.getID(),

			onUpdate: self =>{
				//console.log( self );
				if ( self.progress > 0 ){
					if (  int.getBoundingClientRect().height <= 64.1  ){
						if (self.isActive) {
							this.dom.addClass(this.body, 'desktop-header-sticky');
						}
						else{
							if ( self.progress < 1 ){
								this.dom.removeClass(this.body, 'desktop-header-sticky');
							}
						} 
					}
					else{
						this.dom.removeClass(this.body, 'desktop-header-sticky');
					}
				}
				else{
					this.dom.removeClass(this.body, 'desktop-header-sticky');
				}
				
			},

		});


		if ( this.dom.hasClass( this.body, 'home' ) ){			
			gsap.to( int, {
				height: 64,
				scrollTrigger: {
					trigger: el,
					start: "top top+=20",
					end: '380px',
					scrub: true,
					markers: false,
					id: this.getID(),
					
				}
			});

			gsap.to( logo, {
				width: 280,
				scrollTrigger: {
					trigger: el,
					start: "top top+=20",
					end: '320px',
					scrub: true,
					markers: false,
					id: this.getID(),
				}
			});
		}
	}
	*/

	isMobile(){
		return this.window.innerWidth < 768;
	}

	isDesktop(){
		return this.window.innerWidth >= 1024;
	}

	isTablet(){
		return this.window.innerWidth > 767 && this.window.innerWidth < 1024;
	}

	checkMainWhenOverlapHeader(){
		const 	//h 	= this.dom.qs('#header'),
				hm 	= this.dom.qs('#header-mobile'),
				m  	= this.dom.qs( '#main' );

		//if ( this.options.optimizeMobile && this.isMobile() ) return;
		
		if ( this.isTablet() && this.dom.hasClass( this.body, 'home' ) ) return;

		// desktop
		if ( this.isDesktop() ){
			ScrollTrigger.create({
				trigger: m,
				start: () => { return "top top+=" +  document.querySelector( '.header-desktop .layout' ).offsetHeight + "px"; }, // compact state of header desktop should be "top top+=64px"
				scrub: false,
				markers: false,
				id: this.getID(),
				onToggle: self => {
					if( self.isActive ){
						this.dom.addClass(this.body, 'desktop-header-overlap');
					}
					else{
						this.dom.removeClass(this.body, 'desktop-header-overlap');
					}
				}
			});
		}
		else{


			// mobile
			ScrollTrigger.create({
				trigger: m,
				start: "top top+=" + hm.offsetHeight, // header mobile height
				scrub: false,
				markers: false,
				id: this.getID(),
				onToggle: self => {
					if( self.isActive ){
						this.dom.addClass(this.body, 'mobile-header-overlap');
					}
					else{
						this.dom.removeClass(this.body, 'mobile-header-overlap');
					}
				}
			});
		}
	}

	initScrollText(){
		const el = this.dom.qs( '.scroll-sidebar-effex' );
		if ( !el ) return;	
		if ( this.options.optimizeMobile && this.isMobile() ) return;

		const s = el.querySelector( '.sidebar .text' ), img = el.querySelector( '.image-content' );
		if ( s.offsetHeight > img.offsetHeight ) {
			const d = s.offsetHeight - img.offsetHeight, 
				//y = 64 + parseInt( getComputedStyle( document.querySelector( '.wrap' ) )[ 'marginLeft' ] ); //el.getBoundingClientRect().top;
				y = el.getBoundingClientRect().top;
			
			//console.log( y );
			/*
			el.style.height = img.offsetHeight +  'px';
			el.style.overflow = 'hidden';
			*/

			gsap.to( s, {
				y: - d,
				//duration: 1,
				scrollTrigger:{
					trigger: el,
					start: "top top+=" + (y - 80) + "px", // header desktop compact + margin ( - 80 to allow see the dots for slideshow before lock )
					end: "+=" + d + 'px',
					scrub: true,
					markers: false,
					id: this.getID(),
					pin: el.parentNode,
					pinSpacing: false
				}
			});

		}
	}

	animateBackgroundGradient(){
		const el = this.body; ////this.dom.qs( '#background' );
		if ( !el  ) return;	
		// if ( this.options.optimizeMobile && this.isMobile() ) return;

		const animateColor = true;
		let l = Math.max( this.window.innerHeight/3 , this.getDocHeight() - this.getWindowHeight() );

			// console.log( l );

			l = Math.min( this.window.innerHeight , this.getDocHeight() - this.getWindowHeight() );

			// console.log( l );

		if ( animateColor ){

			const 	colorInit = getComputedStyle(document.documentElement).getPropertyValue('--color-gradient-top'),
					colorEnd = getComputedStyle(document.documentElement).getPropertyValue('--color-gradient-bottom');

			gsap.fromTo( document.documentElement,		
				{	"--color-gradient-top": colorInit },
				{
					"--color-gradient-top": colorEnd,
					ease: "none",
					scrollTrigger: {
						trigger: el,
						markers: false,
						start: "top top",
						end: l,
						id: this.getID(),
						scrub: true,
					}
				}
			);

		}
	}

	initLogoHomeAnimation(){
		if ( !this.dom.hasClass( this.body, 'home' ) ) return;
		if ( this.dom.hasClass( this.htmlEl, 'end-logo-anim' ) ) {
			const el 		= this.dom.qs( '#header' );
			gsap.fromTo( el, {opacity:0}, {opacity:1, duration: 1.4 } );
			this.startMainPromoSlider();
			return;
		}

		//console.log( "HOMEPAGE - init logo animation" );
		
		const desktop = this.isDesktop();
		const mobile = this.isMobile();

		const el 		= desktop ? this.dom.qs( '#header .logo' ) : this.dom.qs( '#header-mobile .logo' ),
				f 		= el.querySelector( '.fondation-l' ),
				t 		= el.querySelector( '.trahan-l' ),
				h 		= el.querySelector( '.h-l' ),
				v 		= el.querySelector( '.v-l' ),
				
				menu	= desktop ? this.dom.qs( '#menu-main-menu' ) : (mobile ? this.dom.qs( '#mobile-panel-open' ) : this.dom.qs( '#menu-main-menu-1' ) ),
				page 	= this.dom.qs( '#smooth-scroll' );

		disableBodyScroll( el );

		this.window.scrollTo(0,0);

		if ( this.anim ) {
			this.anim.kill();
		}

		this.anim = new gsap.timeline();
		let anim = this.anim;

		anim
		.set( [h,v], { drawSVG: "0%" } )
		.set( [f,t], { opacity: 0 } )
		.set( el, { opacity: 1 } );

		// set logo width 100% for mobile
		if ( mobile ){
			anim.set( el, {width:'100%'} );
			// set teh burguer to display none to allow the logo to 100%
			anim.set( menu, { display: 'none' } );
		}
		// horizontal line
		anim.to( h, { drawSVG: "100%", duration: 1.4, ease: "power1.inOut" }, "-=0" )
		.to( v, { drawSVG: "100%", duration: 0.8, ease: "power1.inOut" }, "-=0" )
		.to( f, { opacity:1, duration: 0.8, ease: "power1.inOut" }, "-=0" )
		.to( t, { opacity:1, duration: 0.7, ease: "power1.inOut" }, "-=0" );
		if ( menu ){

			if ( mobile ){
				// set logo width to its size before fading the burger
				anim.to( el, {width: 289, duration: 0.6, ease: 'power2.out'  }, "-=0" );
				anim.set( menu, { display: 'block' } );
			}

			anim.to( menu, { opacity: 1, duration: 0.6, ease: "power1.inOut" }, "-=0" )
		}
		anim.set( page, {opacity: 0, visibility:'visible'} );		
		anim.to( page, { opacity: 1, duration: 1.2, ease: "power1.inOut", onComplete: ()=>{ this.onEndLogoAnimation( el ) } } , "-=0" );
			
		el.style.opacity = 1;

		if ( this.main.options.skip_logo_animation ){
			anim.seek( anim.endTime(), false );
		}
	}

	onEndLogoAnimation( el ){
		this.main.WIDGETS.gdprBar.init();
		this.dom.addClass( this.htmlEl, 'end-logo-anim' )
		enableBodyScroll( el );
		this.main.initScroll( true );
		this.startMainPromoSlider()
	}

	startMainPromoSlider(){
		let promo = this.dom.qs( '.main-promo .swiper' );
		promo.__widget.autoPlay( true );
	}

	/*
	initLogoHomeAnimationOnlyDesktop(){
		if ( !this.dom.hasClass( this.body, 'home' ) ) return;
		if ( this.dom.hasClass( this.htmlEl, 'end-logo-anim' ) ) return;

		this.window.scrollTo(0,0);

		const el 		= this.dom.qs( '#header .logo' ),
				f 		= el.querySelector( '.fondation-l' ),
				t 		= el.querySelector( '.trahan-l' ),
				h 		= el.querySelector( '.h-l' ),
				v 		= el.querySelector( '.v-l' ),
				
				menu	= this.dom.qs( '#menu-main-menu' ),
				page 	= this.dom.qs( '#smooth-scroll' );

		disableBodyScroll( el );

		if ( this.window.innerWidth < 1024 ){
			el.style.opacity = 1;
			return this.onEndLogoAnimation( el );
		}

		let anim = new gsap.timeline();
		anim
		.set( [h,v], { drawSVG: "0%" } )
		.set( [f,t], { opacity: 0 } )
		.set( el, { opacity: 1 } )
		.to( h, { drawSVG: "100%", duration: 0.9, ease: "power1.inOut" }, "-=0" )
		.to( v, { drawSVG: "100%", duration: 0.4, ease: "power1.inOut" }, "-=0.45" )
		.to( f, { opacity:1, duration: 0.8, ease: "power1.inOut" }, "-=0.3" )
		.to( t, { opacity:1, duration: 0.8, ease: "power1.inOut" }, "-=0.3" )

		.to( menu, { opacity: 1, duration: 0.6, ease: "power1.inOut" }, "-=0.2" )
		.to( page, { opacity: 1, duration: 0.8, ease: "power1.inOut", onComplete: ()=>{ this.onEndLogoAnimation( el ) } } , "-=0.4" );
			
		el.style.opacity = 1;
	}
	*/

	/*
	initScrollDownArrow() {
		const el = this.qs('#arrow-blink');
		if (!el) return;

		// scroll if clicked
		const link = el.querySelector('.arrow-link');
		if (link) {
			this.on(link, 'click', (e) => {
				e.preventDefault();
				const target = link.getAttribute('href');
				gsap.to(window, {
					duration: 1.6,
					scrollTo: { y: target, autoKill: false },
					ease: 'Power2.easeInOut'
				});
			});
		}

		// fade arrow on scroll
		gsap.to(el, {
			opacity: 0,
			y: 20,
			scrollTrigger: {
				trigger: this.qs('#main'),
				start: "top top",
				end: '200px',
				scrub: true,
				markers: false,
				id: this.getID()
			}
		});
	}
	*/

	/*
	setNavigationState() {
		// Equivalent of checking body classes and using ScrollTrigger on a trigger element
		if (this.hasClass(this.body, 'home') || this.hasClass(this.body, 'page-template-ideas') || this.hasClass(this.body, 'single-ideas') || this.hasClass(this.body, 'tax-ideas_category')) {

			this.addClass(this.body, 'navigation-white-state');

			const el = this.qs('.trigger-navigation-off-white-state');
			if (el) {
				let topTrigger = 'top';
				const p = el.previousElementSibling;
				if (p) {
					const mb = parseFloat(getComputedStyle(p).marginBottom) || 0;
					topTrigger += '-=' + mb;
				}

				ScrollTrigger.create({
					trigger: el,
					start: topTrigger + " top+=77px",
					end: topTrigger + " top+=77px",
					scrub: false,
					markers: false,
					id: this.getID(),
					onEnter: () => { this.removeClass(this.body, 'navigation-white-state'); },
					onEnterBack: () => { this.addClass(this.body, 'navigation-white-state'); }
				});
			}
		}
	}
	*/

	/*
	lockTimelineSidebar() {
		const el = this.qs('aside .timeline-content');
		if (!el) return;

		// if element has an id, ensure we clear previous trigger
		if (el.id) this.killById(el.id);

		if (window.innerWidth > 767) {
			if (window.innerHeight < el.offsetHeight) return;

			const id = this.getID();
			el.id = id;

			const sidebar = this.qs('.sidebar-right');
			const sidebarTop = sidebar ? sidebar.getBoundingClientRect().top + window.pageYOffset : 0;
			const end = (sidebar ? sidebar.offsetHeight : 0) - (el.getBoundingClientRect().top + window.pageYOffset - sidebarTop) - el.offsetHeight;

			let p = this.qs('.module-sidebar-related-projects');
			let extra = p ? p.offsetHeight + 100 : 0;

			ScrollTrigger.create({
				trigger: el,
				pin: true,
				pinSpacing: false,
				start: 'top+=' + (el.offsetHeight / 2) + 'px center',
				end: '+=' + (end - extra),
				scrub: false,
				id: id
			});
		}
	}
	*/

	/*
	lockShareButtons() {
		const el = this.qs('.sidebar-left .module-share');
		if (!el) return;

		if (el.id) this.killById(el.id);

		if (window.innerWidth > 1023) {
			if (window.innerHeight < el.offsetHeight) return;

			const id = this.getID();
			el.id = id;

			const sidebar = this.qs('.sidebar-left');
			const sidebarTop = sidebar ? sidebar.getBoundingClientRect().top + window.pageYOffset : 0;
			const end = (sidebar ? sidebar.offsetHeight : 0) - (el.getBoundingClientRect().top + window.pageYOffset - sidebarTop) - el.offsetHeight;

			ScrollTrigger.create({
				trigger: el,
				pin: true,
				pinSpacing: false,
				start: 'top-=180px top',
				end: '+=' + end,
				scrub: false,
				id: id
			});
		}
	}
	*/

	
	initMobileTabletHeaderHide() {

		if ( this.isDesktop() ) return;
		const el = this.dom.qs('#header-mobile');
		if (!el) return;

		ScrollTrigger.create({
			trigger: el,
			start: "top top",
			end: () => { return this.getDocHeight() - this.getWindowHeight(); },
			scrub: false,
			markers: false,
			id: this.getID(),

			onUpdate: self => {

				if ( self.progress === 1 ){
					this.dom.removeClass(this.body, 'hide-mobile-header' );
					return;
				}

				const y = self.scroll();
				const yback = el.offsetHeight;
				const direction = self.direction;
				let totalYback = yback;

				if (direction === 1) {
					if (y >= totalYback) {
						this.dom.addClass(this.body, 'hide-mobile-header' );
					}
					else{
						this.dom.removeClass(this.body, 'hide-mobile-header' );
					}
				} else if (direction === -1) {
					
					if ( y > totalYback ) this.dom.removeClass(this.body, 'hide-mobile-header' );
				}

				/*
				if (this.hasClass(this.body, 'activate-nav-compact')) {
					if (direction === 1) this.removeClass(this.body, 'scroll-direction-back');
					else this.addClass(this.body, 'scroll-direction-back');
				}
				*/
			}
		});
	}
	

	/*
	setBurgerPin() {
		const el = this.qs('#burger');
		if (!el) return;

		ScrollTrigger.create({
			trigger: el,
			start: "top top+=10",
			pin: true,
			pinSpacing: false,
			end: () => { return this.getDocHeight() - this.getWindowHeight(); },
			scrub: true,
			markers: false,
			id: this.getID()
		});
	}
	*/

	/*
	setMobileHeaderPin() {
		const el = this.qs('#mobile-header');
		if (el && !this.hasClass(this.body, 'home')) {
			ScrollTrigger.create({
				trigger: el,
				start: "top top",
				pin: true,
				pinSpacing: false,
				end: () => { return this.getDocHeight() - this.getWindowHeight(); },
				scrub: true,
				markers: false,
				id: this.getID()
			});
		}
	}
	*/

	/*
	setBurgerMobilePin() {
		const el = this.qs('#burger-mobile');
		if (!el) return;
		ScrollTrigger.create({
			trigger: el,
			start: "top top+=5",
			pin: true,
			pinSpacing: false,
			end: () => { return this.getDocHeight() - this.getWindowHeight(); },
			scrub: true,
			markers: false,
			id: this.getID()
		});
	}
	*/

	/*
	setMenuSubPagesMobilePin() {
		const el = this.qs('#submenu-pages-mobile');
		if (!el) return;
		ScrollTrigger.create({
			trigger: el,
			start: "top top+=60",
			pin: true,
			pinSpacing: false,
			end: () => { return this.getDocHeight() - this.getWindowHeight(); },
			scrub: true,
			markers: false,
			id: this.getID()
		});
	}
	*/

	/*
	initMobileSubmenuPages() {
		const el = this.qs('.submenu-pages-mobile .scroll-layer');
		if (!el) return;

		// set width based on inner UL width + margin, replace jQuery width calc with native
		const inner = el.querySelector('ul');
		if (inner) el.style.width = Math.ceil(inner.scrollWidth + 70) + 'px';

		// draggable behaviour previously implemented with Draggable (GSAP). If you still use Draggable, re-enable here.
		// set current selection
		setTimeout(() => {
			const current = el.querySelector('li.current-menu-item');
			if (current) {
				const tox = Math.min(current.getBoundingClientRect().left - 20, el.scrollWidth - window.innerWidth);
				gsap.set(el, { x: -tox });
			}
		}, 200);
	}
	*/

	/*
	initSubmenuPages() {
		const el = this.qs('.submenu-pages-desktop');
		if (!el) return;

		const menu = el.querySelector('.menu.horizontal.nav-text');
		const sw = menu ? menu.scrollWidth : 0;
		const w = el.parentElement ? el.parentElement.clientWidth : 0;
		const n = el.parentElement ? (el.parentElement.querySelector('.name') ? el.parentElement.querySelector('.name').clientWidth : 0) : 0;
		let d = false;

		if (sw < w - n - 20) {
			el.style.width = 'auto';
		} else {
			el.style.width = (w - n - 20) + 'px';
			d = true;
		}

		el.style.paddingTop = (window.innerWidth <= 870 ? 3 : 7) + 'px';

		const dMenu = el.querySelector('.menu');
		if (d && dMenu) {
			dMenu.style.paddingRight = '70px';
			const shadow = el.querySelector('.shadow');
			if (shadow) shadow.style.opacity = '1';

			// Draggable usage would go here if needed; set current selection:
			setTimeout(() => {
				const c = dMenu.querySelector('li.current-menu-item');
				if (c) {
					const tox = Math.min(c.offsetLeft, dMenu.scrollWidth - el.clientWidth);
					gsap.set(dMenu, { x: -tox });
				}
			}, 0);
		} else if (dMenu) {
			dMenu.style.paddingRight = '0';
			const shadow = el.querySelector('.shadow');
			if (shadow) shadow.style.opacity = '0';
		}
	}
	*/

	/*
	initModuleHortFiltersSticky() {
		const el = this.qs('.module-hort-filters');
		if (!el) return;

		ScrollTrigger.create({
			trigger: el,
			start: "top top",
			pin: el,
			pinSpacing: false,
			end: () => { return this.getDocHeight() + 100 - this.getWindowHeight(); },
			scrub: true,
			markers: false,
			id: this.getID(),
			toggleClass: 'is-sticky',
			onToggle: self => {
				if (self.direction === 1) document.body.classList.add('is-anchor-menu-sticky');
				else document.body.classList.remove('is-anchor-menu-sticky');
			}
		});
	}
	*/

	/*
	initSubmenuSticky() {
		const el = this.qs('.submenu-pages nav.sticky');
		if (!el) return;

		this.addClass(this.body, 'has-submenu-sticky');

		ScrollTrigger.create({
			trigger: el,
			start: "top top",
			pin: el,
			pinSpacing: false,
			end: () => { return this.getDocHeight() - this.getWindowHeight(); },
			scrub: true,
			markers: false,
			id: this.getID(),
			onToggle: self => {
				if (self.isActive) this.addClass(this.body, 'is-submenu-sticky');
				else this.removeClass(this.body, 'is-submenu-sticky');
			}
		});
	}
	*/

	//-------------------------------------- UTILS -------------------------------//

	initEffectParallaxBackgroundImages() {
	

		const els = this.dom.qsa('.effect-parallax-background');
		if (!els.length) return;
		if ( this.options.optimizeMobile && this.isMobile() ) return;

		els.forEach((el, i) => {

			let imgWrap = el.querySelector('.img-wrapper'),
				scale = _random( 1.1, 1.21 );


			gsap.set( imgWrap, {scale: scale,transformOrigin: 'center top' } );
			//gsap.set( imgWrap, {transformOrigin: 'center top'} );
			let y = Math.floor( el.offsetHeight - imgWrap.offsetHeight*scale );

			gsap.to( imgWrap, {
				y: y,
				ease: "none",
				scrollTrigger: {
					trigger: el,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					markers: false,
					id: this.getID(),
					toggleClass: 'in-view'
				}
			});
		});

	}

	checkImagesInView() {
		const els = this.document.querySelectorAll( 'img' );
		if (!els.length) return;

		/*
		if ( this.options.optimizeMobile && this.isMobile() ){
			els.forEach(el => {
				this.dom.addClass( el, 'in-view' );
			});
			return;
		};
		*/

		els.forEach(el => {
			ScrollTrigger.create({
				trigger: el,
				start: "top bottom",
				end: "bottom top",
				scrub: true,
				markers: false,
				toggleClass: 'in-view',
				once: true
			});
		});
	}




	/*
	initInstagramParallax() {
		const els = this.qsa('.instagram-gallery-item');
		if (!els.length) return;
		if (window.innerWidth < 768 || this.hasClass(this.htmlEl, 'touch')) return;

		els.forEach((el, i) => {
			const pWrap = el.querySelector('.instagram-gallery-item__wrap');
			const p = pWrap ? parseInt(getComputedStyle(pWrap).marginTop) || 0 : 0;
			let v = _random(10, 20);
			let y = (i % 2 !== 0) ? v : -v;

			y = -p * 0.13;
			el.dataset.parallaxYp = y;

			gsap.to(el, {
				yPercent: y,
				ease: "none",
				scrollTrigger: {
					trigger: el,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					markers: false,
					id: this.getID(),
					toggleClass: 'in-view'
				}
			});
		});
	}
	*/

	/*
	initParallaxWorks() {
		const grid = this.qs('.grid-works');
		if (!grid) return;
		if (window.innerWidth < 768 || this.hasClass(this.htmlEl, 'touch')) return;

		const items = grid.querySelectorAll('.item-grid');
		items.forEach((el, i) => {
			let v = _random(10, 20);
			let y = (i % 2 !== 0) ? v : -v;
			const p = el;
			y = -Math.random() * Math.min(70, p.clientWidth * 0.17);
			el.dataset.parallaxYp = y;

			const shake = p.querySelector('.shake');
			if (shake) {
				gsap.to(shake, {
					yPercent: y,
					ease: "none",
					scrollTrigger: {
						trigger: p,
						start: "top top+=" + parseInt((this.qs('#header') ? this.qs('#header').offsetHeight : 0)),
						end: "bottom top",
						scrub: true,
						markers: false,
						id: this.getID(),
						toggleClass: 'in-view'
					}
				});
			}
		});
	}
	*/

	/*
	initEffectParallaxImage() {
		const els = this.qsa('.effect-parallax-image');
		if (!els.length) return;
		if (window.innerWidth < 768 || this.hasClass(this.htmlEl, 'touch')) return;

		els.forEach(el => {
			const p = el.querySelector('.effect-parallax-image-container') || el.querySelector('.img-wrapper');
			const h = el.offsetHeight / 4;
			const o = el.querySelector('.overlay-bg');

			if (p) {
				gsap.to(p, {
					y: h,
					x: o ? '3%' : 0,
					ease: "none",
					scrollTrigger: {
						trigger: el,
						start: "top top",
						end: "bottom top",
						scrub: true,
						markers: false,
						id: this.getID()
					}
				});
			}

			if (o) {
				gsap.to(o, {
					x: '-120%',
					ease: "none",
					scrollTrigger: {
						trigger: el,
						start: "top top",
						end: "center top",
						scrub: true,
						markers: false,
						id: this.getID()
					}
				});

				const slideOverlay = el.querySelector('.slide-overlay');
				if (slideOverlay) {
					gsap.to(slideOverlay, {
						x: '-200%',
						opacity: 0,
						ease: "none",
						scrollTrigger: {
							trigger: el,
							start: "top top",
							end: "center top",
							scrub: true,
							markers: false,
							id: this.getID()
						}
					});
				}
			}
		});
	}
	*/

	/*
	initEffectParallaxImageSmoothTravelling() {
		const els = this.qsa('.smooth-travelling');
		if (!els.length) return;
		if (window.innerWidth < 768 || this.hasClass(this.htmlEl, 'touch')) return;

		els.forEach((el, i) => {
			let v = _random(6, 12);
			let y = _random(6) >= 4 ? v : -v;
			el.dataset.parallaxYp = y;

			gsap.to(el, {
				yPercent: y,
				ease: "none",
				scrollTrigger: {
					trigger: el,
					start: "top center",
					end: "bottom top",
					scrub: true,
					markers: false,
					id: this.getID()
				}
			});
		});
	}
	*/

	/*
	checkView() {
		const els = this.qsa('.check-view');
		if (!els.length) return;

		els.forEach(el => {
			ScrollTrigger.create({
				trigger: el,
				start: "top bottom",
				end: "bottom top",
				scrub: true,
				markers: false,
				toggleClass: 'in-view',
				once: true
			});
		});
	}
	*/

	/*
	initScrollColsAtDifferentSpeed() {
		const el = this.qs('#portfolio');
		if (!el) return;

		// reset the container to its height (if we reinit effect on Resize )
		el.style.height = 'auto';

		const c = this.qs('#col1');
		const c1 = this.qs('#col2');

		let col, colfix, h, h1, d;

		if ((c && c.querySelector('.inner') ? c.querySelector('.inner').offsetHeight : 0) > (c1 && c1.querySelector('.inner') ? c1.querySelector('.inner').offsetHeight : 0)) {
			col = c;
			colfix = c1;
		} else {
			col = c1;
			colfix = c;
		}

		if (!col || !colfix) return;

		h = col.querySelector('.inner').offsetHeight;
		h1 = colfix.querySelector('.inner').offsetHeight;
		d = h1 - h;

		gsap.killTweensOf(col);
		gsap.set(col, { y: 0 });

		gsap.to(col, {
			scrollTrigger: {
				trigger: col,
				start: "top top+=80px",
				end: "bottom bottom",
				toggleActions: "play none reverse none",
				scrub: true
			},
			y: d
		});

		el.style.height = h1 + 'px';
		el.style.overflow = 'hidden';

		const elsMobile = this.qs('#portfolio-mobile');
		if (elsMobile) {
			const items = elsMobile.querySelectorAll('.item-portfolio');
			items.forEach(item => {
				// Here "tap" was a touch plugin; using click as fallback
				this.off(item, 'tap'); // noop if not present
				this.on(item, 'click', (e) => {
					items.forEach(i => {
						if (i === e.currentTarget) i.classList.toggle('active');
						else i.classList.remove('active');
					});
				});
			});
		}
	}
	*/

	/*
	moveFooter(b) {
		if (this.hasClass(this.htmlEl, 'mobile') || this.hasClass(this.htmlEl, 'tablet')) return;

		const target = this.qs('#footer .int');
		const trigger = this.qs('main');

		if (!target || !trigger) return;

		gsap.set(target, { y: 0, opacity: 1 });

		if (!b) return;

		gsap.from(target, {
			scrollTrigger: {
				trigger: trigger,
				start: "bottom bottom",
				end: "+=" + (target.offsetHeight),
				scrub: true,
				id: this.getID()
			},
			y: '40%',
			opacity: 0.9,
			ease: "none"
		});
	}
	*/

	//-------------------------------------------- UTILS ------------------------------//

	getID() {
		const id = 'id_' + this.ids.length;
		this.ids.push(id);
		return id;
	}

	killById(id) {
		if (ScrollTrigger.getById(id)) {
			ScrollTrigger.getById(id).kill();
		}
	}

	destroy() {
		this.addEvents(false);
		//this.moveFooter(false);
		//this.randomizeGradientHover( false );
		if (this.ids.length) {
			let i = this.ids.length;
			while (i--) {
				this.killById(this.ids[i]);
			}
			this.ids = [];
		}
	}

}